import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group";
import { CircleXIcon } from "lucide-react";
import cn from "../../utils/cn";
import { chipVariants, removeIconVariant } from "../Chip/Chip";
const ChipGroupContext = React.createContext({
    size: "regular",
    variant: "default",
    disabled: false,
    color: "primary",
});
const ChipGroupProvider = React.forwardRef(({ className, color, variant, size, disabled, children, ...props }, ref) => (_jsx(ToggleGroupPrimitive.Root, { ref: ref, className: cn("flex items-center justify-center gap-1", className), ...props, children: _jsx(ChipGroupContext.Provider, { value: { variant, size, disabled, color }, children: children }) })));
ChipGroupProvider.displayName = ToggleGroupPrimitive.Root.displayName;
const ChipGroup = React.forwardRef(({ className, children, color, variant, icon, size, deleteIcon, disabled, onDeleteClick, ...props }, ref) => {
    const context = React.useContext(ChipGroupContext);
    const customIcon = (newIcon) => {
        if (!newIcon)
            return null;
        return React.cloneElement(newIcon, {
            className: cn(newIcon?.props?.className || "size-4 mr-2"),
        });
    };
    const pressRemoveClick = onDeleteClick
        ? (e) => {
            e.stopPropagation();
            onDeleteClick();
        }
        : undefined;
    return (_jsxs(ToggleGroupPrimitive.Item, { ref: ref, disabled: context.disabled || disabled, className: cn(chipVariants({
            color: context.color || color,
            variant: context.variant || variant,
            size: context.size || size,
            disabled: context.disabled || disabled,
        }), className), ...props, children: [customIcon(icon), " ", children, " ", deleteIcon && (_jsx(CircleXIcon, { onClick: pressRemoveClick, "data-testid": "remove-icon", className: cn("-mr-1 ml-2 ", removeIconVariant({
                    hover: color,
                    size: size,
                })) })), deleteIcon === false && _jsx("span", { "data-testid": "remove-icon-placeholder", className: "-mr-1 ml-1 size-4" })] }));
});
ChipGroup.displayName = ToggleGroupPrimitive.Item.displayName;
export { ChipGroupProvider };
export default ChipGroup;
